import cn from 'classnames';

/* i18n */
import { FormattedMessage } from 'react-intl';

/* Styles */
import styles from 'styles/layout.module.scss';

/* Assets */
import { logoHeaderUrl, organizationName, logoHeaderMiddleUrl, organizationSubtitle } from 'styles/vars.module.scss';
import info from 'assets/images/Info_MainNav.svg';

/* Analytics */
import { trackEvent } from 'lib/analytics';

/* Redux */
import { useDispatch } from 'react-redux';
import { setLanguage } from 'app/slices/appSlice';

/* Material UI and other UI Dependencies */
import Container from '@material-ui/core/Container';
import Grid from '@material-ui/core/Grid';
import Link from "@material-ui/core/Link";
import withWidth from '@material-ui/core/withWidth';
import Box from '@material-ui/core/Box';

function Header({locale, handleDrawerOpen, width, loggedIn}) {

  const smallScreen = ['xs', 'sm'].indexOf(width) > -1;

  const dispatch = useDispatch();

  const resetLanguage = () => {
    if ( typeof window !== 'undefined' ) {
      const language = locale === 'en' ? 'es' : 'en';
      localStorage.setItem('lng', language);
      dispatch(setLanguage(language));
      const eventName = `I_MENU_${ locale === 'en' ? 'ESPANOL' : 'ENGLISH'}`;
      trackEvent(eventName);
      window.location.href = locale === 'en' ? '/#/es/' : '/#/';
    }
  }

  return (
    <div className={styles.header}>
      <Container maxWidth="lg">
        <Grid container className={styles.headerContent}>
          <Grid item xs={4} className={styles.headerLeftCell}>
            <a
              href="https://dlt.ri.gov/"
              target="_blank"
              rel="noreferrer"
            >
              <img
                className={cn({
                  [styles.headerLogo]: true,
                  [styles.hidden]: smallScreen
                })}
                src={logoHeaderUrl.slice(1, -1)}
                alt={organizationName}
              />
            </a>
            <Box px={1} display="inline-block" />
            <Link
              href={locale === 'en' ? '/#/es/' : '/#/'}
              className={cn({
                [styles.link]: true,
                [styles.hidden]: !smallScreen
              })}
              onClick={resetLanguage}
              underline="always"
            >
              <FormattedMessage id="layout.language" default="Español" />
            </Link>
          </Grid>
          <Grid item xs={4} justify="center" container>
            <a
              href="https://www.backtoworkri.com/"
              target="_blank"
              rel="noreferrer"
            >
              <img
                className={cn({
                  [styles.headerLogoMiddle]: true,
                  [styles.hidden]: smallScreen
                })}
                src={logoHeaderMiddleUrl.slice(1, -1)}
                alt={organizationSubtitle}
              />
            </a>
          </Grid>
          <Grid item xs={4} justify="flex-end" alignItems="center" container wrap="nowrap">
            <span
              className={cn({
                [styles.link]: true,
                [styles.hidden]: smallScreen
              })}
              onClick={resetLanguage}
            >
              <FormattedMessage id="layout.language" default="Español" />
            </span>              
            {loggedIn ? (
              <>
                <Link
                  href="#"
                  className={cn({
                    [styles.link]: true,
                    [styles.infoIcon__container]: true
                  })}
                  onClick={handleDrawerOpen}
                >
                  <img className={styles.infoIcon} alt="Information" src={info} />
                </Link>
              </>
            ) : (
              <Box px={1} display="inline-block" />
            )}              
          </Grid>
        </Grid>
      </Container>
    </div>
  )
}

export default withWidth()(Header);